import React from 'react';
import PropTypes from 'prop-types';

export default class ToggleSwitch extends React.PureComponent {
    static propTypes = {
        /** The id of the element serving as the toggle's label */
        labelledBy: PropTypes.string.isRequired,

        /** If true, toggle is in on position */
        isOn: PropTypes.bool.isRequired,

        /** Change handler */
        onClick: PropTypes.func.isRequired,

        /** If true, toggle is visually dimmed and disabled */
        isDisabled: PropTypes.bool,

        /** Label for the Off switch */
        offLabel: PropTypes.string,

        /** Label for the On switch */
        onLabel: PropTypes.string
    };

    static defaultProps = {
        isDisabled: false,
        offLabel: 'Off',
        onLabel: 'On'
    };

    render() {
        const { isOn, isDisabled, labelledBy, offLabel, onLabel, onClick, ...rest } = this.props;

        return (
            <button
                type="button"
                className="rec-toggle-switch"
                aria-pressed={isOn}
                aria-labelledby={labelledBy}
                disabled={isDisabled}
                onClick={onClick}
                {...rest}>
                <span className="rec-toggle-switch-label" data-dimmed={isOn}>{offLabel}</span>
                <span className="rec-toggle-switch-stick" data-pressed={isOn}>
                    <span className="rec-toggle-switch-ball" data-pressed={isOn} />
                </span>
                <span className="rec-toggle-switch-label" data-dimmed={!isOn}>{onLabel}</span>
            </button>
        );
    }
}
